import { memo, useState } from 'react';
import { bridgeAtom, useValue } from '@/store';
import { ChoiceType } from '../../data';
import { ChoiceButton, FindButton, FindContainer, MultiChoiceMessageContainer } from './MultiChoice.styled';

export const MultiChoice = memo<ChoiceType>((props) => {
  const { options, sendMessage, disabled } = props;

  const { translations } = useValue(bridgeAtom);

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const handleChoiceClick = (option: string) => {
    if (disabled) {
      return;
    }

    setSelectedOptions((prevSelected) => {
      if (prevSelected.includes(option)) {
        return prevSelected.filter((o) => o !== option); // Deselect the option if already selected
      } else {
        return [...prevSelected, option]; // Select the option
      }
    });
  };

  const handleFindClick = () => {
    if (disabled) {
      return;
    }

    // Send the selected options joined by a comma
    sendMessage(selectedOptions.join(', '), selectedOptions);
  };

  return (
    <>
      <MultiChoiceMessageContainer>
        {options.map((option, index) => (
          <ChoiceButton
            key={index}
            selected={selectedOptions.includes(option)}
            onClick={() => handleChoiceClick(option)}
            disabled={disabled}
          >
            {option}
          </ChoiceButton>
        ))}
      </MultiChoiceMessageContainer>

      <FindContainer>
        <FindButton onClick={handleFindClick} disabled={selectedOptions.length === 0 || disabled}>
          {window.LLL(translations.multiChoiceFindButton)}
        </FindButton>
      </FindContainer>
    </>
  );
});

MultiChoice.displayName = 'MultiChoice';
